import { Vue } from "vue-property-decorator"
import { Pagination } from "@/model/interfaces/pagination"
import PaginationUtils from "@/services/utils/PaginationUtils"
import { FaoCountry } from "@/model/interfaces/fao/faoCountry"
import { HarmonizationSettingSubmissionFaoCountry } from "@/model/interfaces/harmonizationSettings/FaoCountry/harmonizationSettingSubmissionFaoCountry"

export default class FaoCountryService {
  private static URI = "fao_countries"

  static async get(pagination: Pagination): Promise<{ faoCountries: FaoCountry[]; pagination: Pagination }> {
    const response = await Vue.$axios.get(this.URI, {
      params: {
        ...PaginationUtils.normalizePagination
      }
    })

    const { current, last } = PaginationUtils.parseCurrentLast(response)

    return {
      faoCountries: response.data["hydra:member"],
      pagination: {
        current: current,
        itemsPerPage: pagination.itemsPerPage,
        last: last,
        itemCount: response.data["hydra:totalItems"]
      }
    }
  }

  static async patch(faoCountry: Partial<FaoCountry>): Promise<FaoCountry> {
    const response = await Vue.$axios.patch(this.URI + "/" + faoCountry.id, faoCountry)
    return response.data
  }
}
